<template>
  <div class="UserCenter linear-main3">
    <div class="container">
      <ld-statusbar />

      <!-- 顶部条 -->
      <van-row
        type="flex"
        class="setting"
        align="center"
      >
        <van-col span="22">
          <router-link
            v-ldsk="userInfo&&userInfo.vipCorp?userInfo.vipCorp.corpNo:''"
            class="white font16"
            to="/userCenter/company"
          >
            <ld-icon
              type="icongongsidizhi"
              :size="19"
            />
            {{ userInfo&&userInfo.vipCorp?userInfo.vipCorp.fullname:'' }}
          </router-link>
        </van-col>

        <van-col v-if="!isGat() && setshow"
                 class="text-right"
                 span="2"
        >
          <router-link to="/userCenter/settings">
            <van-icon
              class="white"
              name="setting-o"
              size="28"
            />
          </router-link>
        </van-col>
      </van-row>
      <div class="centerwrapper">
        <mescroll-vue
          ref="mescroll"
          :down="down"
        >
          <div class="pad-b-50">
            <!-- 信息栏 -->
            <div class="info-card bg-white shadow round-md">
              <van-row
                type="flex"
                gutter="10"
                v-if="Object.keys(userInfo).length > 0"
              >
                <van-col
                  span="4"
                  class="chatface flex-clear"
                >
                  <router-link to="/userCenter/userInfo">
                    <ld-icon
                      class="main-color"
                      size="44"
                      type="iconweibiaoti-"
                    />
                  </router-link>
                </van-col>
                <van-col>
                  <div class="empName font16 font-lg">
                    {{ userInfo&&userInfo.empInfo?userInfo.empInfo.empName:'' }}
                  </div>
                  <div class="empNo font12 white">
                    <span class="icon-id">ID</span>
                    {{ userInfo&&userInfo.empInfo?userInfo.empInfo.empNo:'' }}
                  </div>
                </van-col>
              </van-row>
              <van-row type="flex" justify="center" v-else>
                <van-button plain class="linear-main1" to="/login" round>登录/注册</van-button>
              </van-row>

              <!-- 订单信息栏 -->
              <van-grid :border="false">
                <van-grid-item
                  :class = "(val == 1)?'orderStyle':''"
                  v-for="tab in ((val == 1) ? tabbarList : tabList)"
                  style="justify-content: space-around;"
                  :key="tab.link"
                  :to="{ path: tab.link, query: tab.query }"
                >
                  <template #icon>
                    <ld-icon
                      class="normal"
                      size="32"
                      gradient
                      icon-class="linear-main2"
                      :type="tab.img"
                    />
                  </template>
                  <template #text>
                    <span class="deep-gray font12">{{ $t(tab.title) }}</span>
                  </template>
                </van-grid-item>
              </van-grid>

              <!-- 消息栏 -->
              <van-row
                v-if="loginNotices&&loginNotices.length"
                type="flex"
                align="center"
                class="message"
              >
                <van-col span="2">
                  <img
                    class="icon-new"
                    src="~Assets/images/home/icon_new.png"
                  >
                </van-col>
                <van-col span="22">
                  <van-notice-bar
                    mode="link"
                    @click="$router.push({ path: '/noticeList' })"
                  >
                    <span
                      v-for="notice in loginNotices"
                      :key="notice.id"
                      class="font12 black"
                      style="margin-left: 30px"
                    >
                      {{ notice.content }}
                    </span>

                    <template #right-icon>
                      <van-icon
                        class="van-notice-bar__right-icon main-color"
                        name="arrow"
                      />
                    </template>
                  </van-notice-bar>
                </van-col>
              </van-row>

              <div class="overflow-auto" />
            </div>

            <van-row
              type="flex"
              gutter="20"
              align="center"
              class="service bg-white shadow round-md"
              @click="$router.push({ path: '/service' })"
            >
              <van-col
                span="4"
                class="service-icon"
              >
                <van-icon
                  class="main-color"
                  name="service"
                />
              </van-col>
              <van-col
                class="van-hairline--left"
                span="17"
              >
                <div class="font-lg">
                  {{ $t('A022','专属客服') }}
                </div>
                <div class="gray">
                  {{ $t('Q305','24小时专属客服，一对一服务') }}
                </div>
              </van-col>
              <van-col span="3">
                <ld-icon type="iconright" />
              </van-col>
            </van-row>

            <van-cell-group class="nav-list shadow round-md">
              <van-cell
                v-for="(nav, i) in subNavList"
                :key="i"
                :title="$t(nav.title)"
                is-link
                :to="{ path: nav.link, query: nav.query }"
                v-show="Dragonpot(i,nav)"
              >
                <ld-icon
                  class="gray"
                  slot="icon"
                  size="20"
                  :type="nav.img"
                />
              </van-cell>
            </van-cell-group>

            <van-cell-group
              class="nav-list shadow round-md"
              style="margin-top: 5px;"
            >
              <van-cell
                v-for="(nav, i) in navList"
                :key="i"
                :title="$t(nav.title)"
                is-link
                :to="{ path: nav.link, query: nav.query }"
              >
                <ld-icon
                  class="gray"
                  slot="icon"
                  size="20"
                  :type="nav.img"
                />
              </van-cell>
              <van-cell
                :title="'积分充值'"
                @click="toSkForPoint"
              >
                <ld-icon
                  class="gray"
                  slot="icon"
                  size="20"
                  type="iconweibiaoti-146"
                />
              </van-cell>
            </van-cell-group>
          </div>
        </mescroll-vue>
      </div>
    </div>

  </div>
</template>

<script>
import { Tabbar, TabbarItem, NoticeBar, Cell, CellGroup ,Grid, GridItem,Button } from 'vant'
import { mapGetters } from 'vuex'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { localget } from 'Utils/storage.js'
import ldStatusbar from 'Common/ldStatusbar'
import { getParameter } from 'Utils/publicApi'
import { isGat } from 'Utils/gattools';

// const tabbarList = [
//   {
//     link: '/allorder?findType=2',
//     title: 'A101',//待付款
//     img: 'icontianchongxing-'
//   },
//   {
//     link: '/allorder?findType=3',
//     title: 'A102',//待出行
//     img: 'iconhanglixiang'
//   },
//   {
//     link: '/allorder?findType=4',
//     title: 'A103',//退/改签
//     img: 'icontuikuan'
//   },
//   //弃用,用配置动态加载
//   // {
//   //   link: '/userCenter/reserveRebook',
//   //   title: '预留改签',//预留改签'
//   //   img: 'iconweibiaoti-145'
//   // },
//   {
//     link: '/allorder?findType=1',
//     title: 'A104',//全部订单
//     img: 'icondingdan'
//   }
//
// ]

export default {
  name: 'UserCenter',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [NoticeBar.name]: NoticeBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]: Button,
    MescrollVue,
    ldStatusbar
  },
  data () {
    return {
      tabbarList:[
        {
          link: '/allorder?findType=2',
          title: 'A101',//待付款
          img: 'icontianchongxing-'
        },
        {
          link: '/allorder?findType=3',
          title: 'A102',//待出行
          img: 'iconhanglixiang'
        },
        {
          link: '/allorder?findType=4',
          title: 'A103',//退/改签
          img: 'icontuikuan'
        },
        //弃用,用配置动态加载
        // {
        //   link: '/userCenter/reserveRebook',
        //   title: '预留改签',//预留改签'
        //   img: 'iconweibiaoti-145'
        // },
        {
          link: '/allorder?findType=1',
          title: 'A104',//全部订单
          img: 'icondingdan'
        }

      ],
      subNavList: [
        {
          link: '/userCenter/approvalList',
          query: { index: 2 },
          title: 'K206',//需要我审批
          img: 'iconweibiaoti-145'
        },
        {
          link: '/userCenter/approvalList',
          query: { index: 3 },
          title: '我提交的审批',
          img: 'iconweibiaoti-143'
        },
        // {
        // 	link: '/userCenter/NeedOrder',
        // 	title: '我的需求单',//我的需求单
        // 	img: 'iconweibiaoti-147'
        // },
        {
          link: '/tripList',
          title: '我的出差申请',
          img: 'iconweibiaoti-142'
        },
      ],
      navList: [
        {
          link: '/userCenter/CommonInfo',
          title: 'A107',//常用信息
          img: 'iconweibiaoti-146'
        },
        {
          link: '/userCenter/empList',
          title: 'A108',//员工管理
          img: 'iconyonghuguanli'
        },
        // {
        // 	link: '/userCenter/invitEmployees',
        // 	title: '邀请员工', //邀请员工
        // 	img: 'iconadduser'
        // },
      ],
      down: { use: false },
      //弃用，统一用tabbarList
      tabList: [
        {
          link: '/allorder?findType=2',
          title: 'A101',//待付款
          img: 'icontianchongxing-'
        },
        {
          link: '/allorder?findType=3',
          title: 'A102',//待出行
          img: 'iconhanglixiang'
        },
        {
          link: '/allorder?findType=4',
          title: 'A103',//退/改签
          img: 'icontuikuan'
        },
        {
          link: '/allorder?findType=1',
          title: 'A104',//全部订单
          img: 'icondingdan'
        }
      ],
      val: 0,
      setshow:false,
    }
  },
  computed: {
    ...mapGetters(['loginConfig', 'userInfo', 'loginNotices'])
  },
  async created() {
    if(Object.keys(this.userInfo).length > 0  && Object.keys(this.userInfo).length != 0){
      const  my  = await this.$api['common/queryVipParameter']({paramNo:'11605011'}) //我的
      my.data.value1==1 ? this.setshow=false :this.setshow=true
    }else{
      this.setshow=true
    }

    // 如果是GAT公司，删除邀请员工入口
    if (isGat()) {
      this.navList.splice(2, 1)
    }

    if(!this.userInfo||!this.userInfo.vipCorp){
      let userInfo = localget('userInfo')
      if(userInfo){
        this.$store.commit('SET_USERINFO',userInfo)
      }
    }

    if(this.userInfo.vipCorp){
      if(this.userInfo.vipCorp.bookStyle==1){
        this.subNavList.splice(3, 1)
      }
    }else{
      let userInfo = localget('userInfo')
      if(userInfo){
        this.$store.commit('SET_USERINFO',userInfo)
        //如果是单订模式 删除申请单的入口
        if (userInfo.vipCorp && userInfo.vipCorp.bookStyle==1) {
          this.subNavList.splice(3, 1)
        }
      }
    }
    await getParameter('11601006').then(res => {
      console.log("resres11601006,{}",res)
      if (res.value1 && (res.value1 == 1 || res.value1 == '1')) {
        this.val = 1
        this.tabbarList.push({
          link: '/userCenter/reserveRebook',
          title: '预留改签',//预留改签'
          img: 'iconweibiaoti-145'
        })
      }
    })

    // app/h5指定企业下隐藏数电发票按扭 1：隐藏 0：展示
    await this.$api['common/queryVipParameter']({paramNo:'11605112'}).then(res => {
      console.log("11605112{}",res)
      this.val = 1
      if (res.data.value1 == 0 || res.data.value1 == '0') {
        console.log("展示数电发票按扭 {}",res)
        this.tabbarList.push({
          link: '/userCenter/billInvoice',
          title: '数电发票',//预留改签'
          img: 'iconweibiaoti-145'
        })
      }
    })

  },
  methods:{
    isGat,
    Dragonpot(index,nav){
      let AutoLogin=JSON.parse(localStorage.getItem("AutoLogin") || '{}')
      if(AutoLogin && AutoLogin.corpId=='5c2af988ea444905876ea8541ef6c769'&& (index== 0 || index==2)){//生产哈锅
        return false
      }
      return true
    },
    // 跳转到SK的积分充值
    toSkForPoint() {
      this.$api["common/tmcToSkPoint"]({}).then(res => {
        console.log(res)
        debugger;
        if (res.errCode != '1') {
          this.$toast(res.errMsg || '跳转失败，请稍后再试')
        } else {
          // 跳转到SK的积分充值
          const backUrl = encodeURIComponent(location.href)
          location.href = res.data.turnUrl + `/#/recharge?gat_zt_token=${res.data.token}&from=gat_zt_app_h5&back_url=${backUrl}`;
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.UserCenter {
     height: 100%;
    .centerwrapper {
        height: calc(100vh - 122px);
         -webkit-overflow-scrolling: touch;
    }
    .pad-b-50{
        padding-bottom: 60px;
    }

  .container {
    padding: 8px 8px 0;

    .setting {
      padding: 20px 10px;
    }

    .info-card {
      margin-top: 5px;
      padding: 15px;
      box-shadow: 0px 6px 10px 0px
        rgba(24, 23, 23, 0.02);

      .chatface {

        img {
          vertical-align: text-top;
        }
      }

      .empNo {
        padding: 2px 8px;
        //background-image: linear-gradient(90deg,
        //  #556070 0%,
        //  #7a7e85 100%);
        background-color: #ff923e;
        background-blend-mode: normal,
          normal;
        border-radius: 20px;
        margin-top: 0.2rem;

        .icon-id {
          color: #f6e9e3;
        }
      }
    }

    .orderStyle{
        flex-basis:20% !important;
      }


    .message {
      border-top: 1px solid @color-background-gray;
      padding: 8px 0;

      .icon-new {
        width: 28px;
        vertical-align: middle;
      }

      .van-notice-bar {
        height: 24px;
        padding: 0 5px;
        background: transparent;
      }
    }

    .service {
      margin: 5px 0 !important;

      h4, p {
        margin: 0;
      }

      .service-icon {
        text-align: center;
        padding: 14px !important;

        i {
          font-size: 32px;
        }
      }
    }

    .nav-list {
      overflow: hidden;

      .van-cell {
        padding: 16px;

        .van-cell__title {
          font-size: @font-size-14
        }
      }

      .iconfont {
        margin-right: 12px;
      }
    }
  }
}
</style>
